import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { get } from 'lodash';
import Button from '../../elements-buttons/Button';
import { Payment } from '../../elements-forms/payment-old';
import { TosCTAdisclaimer } from 'shared-components/terms/cta-disclaimer';
import ApplyCreditField from '../../app-main/components/reduxForms/fields/ApplyCreditField/ApplyCreditField';
import {
  normalizedContractsShape,
  verifyPSCredits
} from '../../app-bookings-request/forms/bookingUtil';
import { FormattedMessage, injectIntl } from 'react-intl';
import WriteIcon from 'shared-components/icons/Write';
import { BookingDetailsReview } from './BookingDetailsReview';

const ReviewUpdate = ({
  priceBreakdown,
  contract,
  paymentInfo,
  selectedPayment,
  paymentActionFn,
  handleListClickCb,
  storeCardInstance,
  handleBackClick,
  activityDetailBooking,
  processing,
  errorText,
  credits = {},
  handleApplyCreditChange = null,
  applyCreditProcessing,
  pendingContracts,
  currentContracts,
  spaceRental = {},
  intl,
  alcoholConsumed,
  profile
}) => {
  const { currency, updateDifference, creditsApplied } = priceBreakdown;

  const creditBalance = get(credits, 'balance', 0);
  const dueNow = updateDifference?.due_now || 0;

  const listing = get(spaceRental, 'meta.listing', {});
  const psCreditsAllowed = verifyPSCredits(listing);

  return (
    <div className='tables'>
      <h5 className='h5 margin-xl-top margin-xl-bottom flex middle'>
        <WriteIcon />
        <span className='margin-md-left'>Booking details</span>
      </h5>
      <BookingDetailsReview
        booking={activityDetailBooking}
        alcoholConsumed={alcoholConsumed}
      />

      {(paymentInfo && dueNow > 0) && (
        <div data-testing-id='review-update-additional-payment'>
          <hr className='full-width margin-xl-top' />
          <div className='payment-section margin-xl-bottom'>
            {!!creditBalance && psCreditsAllowed && (
              <div
                className='apply-credit-section margin-lg-bottom'
                data-testing-id='review-update-additional-payment-credits'
              >
                <div className='heavy'>
                  <FormattedMessage
                    id='inbox_guest_update_booking.review_update.peerspace_credits'
                    defaultMessage='Peerspace Credits'
                  />
                </div>
                <Field
                  name='apply_credit'
                  component={ApplyCreditField}
                  currency={currency}
                  creditBalance={creditBalance}
                  onChange={handleApplyCreditChange}
                  isProcessing={applyCreditProcessing}
                  creditsApplied={creditsApplied}
                />
              </div>
            )}

            <div>
              <Field
                name={selectedPayment ? 'payment' : 'cardholders_name'}
                title={intl.formatMessage({
                  id: 'inbox_guest_update_booking.review_update.payment_method',
                  defaultMessage: 'Payment Method'
                })}
                component={Payment}
                useBootstrapGrid={false}
                paymentInfo={paymentInfo}
                actionFn={paymentActionFn}
                handleListClickCb={handleListClickCb}
                returnStripeCardInstance={storeCardInstance}
                inReduxForm
              />
            </div>
          </div>
        </div>
      )}

      <hr />
      <div className='help-block text-danger text-left'>{errorText}</div>

      <div className='col-xs-12 flex space-between no-gutter column-xs-reverse'>
        <Button
          type='button'
          className='btn btn-default classic full-height'
          onClick={handleBackClick}
          attributes={{
            'data-testing-id': 'review-update-back-btn'
          }}
        >
          <FormattedMessage
            id='inbox_guest_update_booking.review_update.back'
            defaultMessage='Back'
          />
        </Button>

        <Button
          attributes={{ 'data-testing-id': 'booking-details-next-btn' }}
          category='primary'
          isLoading={processing}
          disabled={processing}
          className='margin-md-bottom'
        >
          <FormattedMessage
            id='inbox_guest_update_booking.review_update.request_update'
            defaultMessage='Request Booking Update'
          />
        </Button>
      </div>

      <TosCTAdisclaimer
        location='requestBkgNewTab'
        buttonLabel={intl.formatMessage({
          id: 'inbox_guest_update_booking.review_update.request_label',
          defaultMessage: 'Request Booking Update'
        })}
      />
    </div>
  );
};

ReviewUpdate.propTypes = {
  priceBreakdown: PropTypes.object,
  profile: PropTypes.object,
  contract: PropTypes.object,
  paymentInfo: PropTypes.array,
  selectedPayment: PropTypes.object,
  paymentActionFn: PropTypes.func,
  handleListClickCb: PropTypes.func,
  storeCardInstance: PropTypes.func,
  handleBackClick: PropTypes.func,
  activityDetailBooking: PropTypes.object,
  processing: PropTypes.bool,
  errorText: PropTypes.string,
  currentContracts: normalizedContractsShape,
  pendingContracts: normalizedContractsShape
};

export default injectIntl(ReviewUpdate);
